module.exports = __webpack_public_path__ + "img/login-page-img.22c5eb38.png";